import { FC } from 'react';
import { Outlet } from 'react-router-dom';

import LogoMain from '@/assets/svg/logos/logo-main.svg';
import LogoMark from '@/assets/svg/logos/logo-mark.svg';
import { PagePaths } from '@/routes/page-paths';

import { Header, HeaderInner, HeaderLogo, HeaderLogoLink, LayoutRoot, Main } from './styled';

/**
 * Shell for pages a signed-out visitor reaches by link: a logo strip and nothing else, so the page
 * itself carries the content and no app navigation leaks into it.
 */
export const PublicLayout: FC = () => (
  <LayoutRoot>
    <Header>
      <HeaderInner>
        <HeaderLogoLink to={PagePaths.root} aria-label="Go to Gamma Prime">
          <HeaderLogo role="img" aria-label="Gamma Prime">
            <LogoMain data-logo="desktop" aria-hidden="true" focusable="false" />
            <LogoMark data-logo="mobile" aria-hidden="true" focusable="false" />
          </HeaderLogo>
        </HeaderLogoLink>
      </HeaderInner>
    </Header>
    <Main>
      <Outlet />
    </Main>
  </LayoutRoot>
);
